import React, { useEffect, useMemo, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
} from "@material-tailwind/react";
import { moviesData, ebooksData, sortingData } from "../Constant/Data";
import MyItemsCard from "./MyItemsCard.jsx";
import { useReduxStore } from "../hooks/useReduxStore";
import { GetBuyItemsAction } from "../store/Actions/action";
import EmptyList from "./EmptyList";
import Pagination from "./Pagination";
import { emptyItem } from "../assets/Images";
import { updateItem } from "../store/Reducers/itemReducer";
import { scrollToTop, sorting } from "../helper/helper";
import SelectBoxSimple from "./SelectBoxSimple";
export default function MyItemsSection({ selected = "All", dark = true }) {
  const [sortBy, setSortBy] = useState(null);
  const { getState, dispatch } = useReduxStore();
  const { buyItems, totalItemsCount, currentPage, lastPage, perPageCount } =
    getState("Item");
  const { loading } = getState("AUTH");
  const listData = useMemo(() => {
    return sorting(
      [...buyItems],
      sortBy?.id === 2 ? "desending" : sortBy?.id === 1 ? "assending" : null
    );
  }, [sortBy, buyItems]);
  const onSorting = (item) => {
    setSortBy(item);
  };
  const getBuyItems = (page) => {
    dispatch(GetBuyItemsAction({ page: page || currentPage }));
    scrollToTop();
  };
  useEffect(() => {
    getBuyItems();
  }, []);
  useEffect(() => {
    return () => {
      dispatch(updateItem({ items: [], currentPage: 1 }));
    };
  }, []);
  return (
    <div className={`w-full rounded-xl p-4 md:p-8 shadow-2xl border ${
      dark 
        ? "bg-zinc-950 border-zinc-900 text-white" 
        : "bg-white border-gray-100 text-black md:shadow-lg"
    }`}>
      <div className="flex justify-between items-center py-4">
        <h4 className={`text-xl font-bold sm:text-3xl text-center lg:text-left ${dark ? "text-white" : "text-black"}`}>
          Your Items
        </h4>
        <SelectBoxSimple
          data={[...sortingData]}
          label={"Sort By"}
          onItemClick={onSorting}
          selected={sortBy}
          dark={dark}
        />
      </div>
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 3xl:grid-cols-2 mt-4">
        {listData.map((item, i) =>
          item?.product_details ? (
            <li key={item?.product_details?.id || i}>
              <MyItemsCard
                {...item.product_details}
                item={item?.product_details}
                dark={dark}
              />
            </li>
          ) : null
        )}
      </ul>
      {!loading && !buyItems?.length && (
        <EmptyList
          description={"There is no items in your buy list"}
          image={emptyItem}
          dark={dark}
          btn={false}
        />
      )}
      {listData?.length && listData.length > 9 ? (
        <Pagination
          {...{
            totalItemsCount,
            currentPage,
            lastPage,
            perPageCount,
            onBtnClick: getBuyItems,
            dark: dark,
          }}
        />
      ) : null}
    </div>
  );
}
